import React from 'react';
import { Create } from 'react-admin';
import LocationForm from './form';

const LocationCreate = (props) => {
  const { resource } = props;

  return (
    <Create title={`resources.${resource}.titles.create`} {...props}>
      <LocationForm />
    </Create>
  );
};

export default LocationCreate;
